<!--suppress HtmlUnknownTarget -->
<template>
  <div id="featureDualContentVideoCardRoot">
    <div id="container">
      <div id="leftContainer">
        <FeatureInfoContainerCard style="height: 70%" v-on:is-expanded="toggleLeft" :open-icon-position="iconPosition"
                                  background-color="#FDFDFA">
          <div id="leftContent">

            <transition name="fade">
              <div v-if="!leftExpanded" class="titleContainer">
                <div class="title h2"><span v-html="leftContent.title"></span></div>
                <div class="titleDescription"><span v-html="leftContent.description"></span></div>
              </div>
            </transition>

            <transition name="fade">
              <div v-if="!leftExpanded" id="leftMedia">
                <video @contextmenu.prevent id="leftVideo" ref="leftVideo" playsinline muted>
                  <source :src="leftVideo" type="video/mp4"/>
                </video>
              </div>
            </transition>

            <transition name="fade">
              <div v-if="leftExpanded" id="leftExpandedDescription">
                <span v-html="leftContent.expandedDescription"></span>
              </div>
            </transition>
          </div>
        </FeatureInfoContainerCard>
      </div>

      <div id="rightContainer">
        <div id="rightMedia">
          <video @contextmenu.prevent id="rightVideo" ref="rightVideo"
                 playsinline muted preload="metadata">
            <source :src="rightVideo" type="video/mp4"/>
          </video>
        </div>
        <div id="rightTitleContainer" class="titleContainer">
          <div id="rightTitle" class="title h2"><span v-html="rightContent.title"></span></div>
          <div id="rightTitleDescription" class="titleDescription"><span v-html="rightContent.description"> </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FeatureInfoContainerCard from "./FeatureInfoContainerCard";

export default {
  components: {FeatureInfoContainerCard},
  props: {
    height: {
      type: Number,
      default: 0
    },

    name: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    taglineDescription: {
      type: String,
      default: ""
    },
    tagline: {
      type: String,
      default: ""
    },
    content: {
      type: Array,
    },
  },
  data() {
    return {
      leftExpanded: false,
      rightExpanded: false
    }
  },
  watch: {
    offset(newVal, oldVal) {
      this.determineLeftContainerVideoState(newVal, oldVal)
      this.determineRightContainerVideoState(newVal, oldVal)
    }
  },
  computed: {
    leftContent() {
      return this.content[0];
    },
    rightContent() {
      return this.content[1];
    },
    leftVideo() {
      return require('@/assets/' + this.leftContent.media);
    },
    rightVideo() {
      return require('@/assets/' + this.rightContent.media);
    },
    offset() {
      return this.$store.state.scrollOffset
    },
    leftContainerPlayTrigger() {
      let trigger = 0;
      if (this.height > 812)
        trigger = (this.height * 1.3)
      else if (this.height <= 812)
        trigger = (this.height * 1.6)
      return trigger;
    },
    leftContainerPauseTrigger() {
      let trigger = 0;
      if (this.height > 812)
        trigger = (this.height * 0.6)
      else if (this.height <= 812)
        trigger = (this.height * 0.5)
      return trigger;
    },
    rightContainerPlayTrigger() {
      let trigger = 0;
      if (this.height > 812)
        trigger = (this.height * 1.3)
      else if (this.height <= 812)
        trigger = (this.height * 3.4)
      return trigger;
    },
    rightContainerPauseTrigger() {
      let trigger = 0;
      if (this.height > 812)
        trigger = (this.height * 0.5)
      else if (this.height <= 812)
        trigger = (this.height * 3.2)
      return trigger;
    },
    iconPosition() {
      if (this.height > 812)
        return 3
      else
        return 1
    }
  },
  methods: {
    toggleLeft(value) {
      this.leftExpanded = value
      this.$gtag.event('featureToggle', {
        eventCategory: 'weighted_interaction',
        eventAction: 'click',
        eventValue: value ? 1 : 0
      })
    },
    toggleRight(value) {
      this.rightExpanded = value
    },
    position(val) {
      let position = 0;
      if (this.height > 812)
        position = (val - (this.height * 2.2));
      else if (this.height <= 812)
        position = (val - (this.height * 2.6));
      return position;
    },
    determineLeftContainerVideoState(newVal, oldVal) {
      let oldPosition = this.position(oldVal);
      let newPosition = this.position(newVal);
      let pausetrigger = this.leftContainerPauseTrigger;
      let playTrigger = this.leftContainerPlayTrigger;
      // console.log("PAUSETRIGGER", pausetrigger)
      // console.log("PLAYTRIGGER", playTrigger)
      // console.log("position", newPosition)
      if (oldPosition <= playTrigger) {
        if (newPosition > playTrigger) {
          // console.log("PLAY", oldVal)
          if (this.$refs.leftVideo.currentTime === 0)
            this.$refs.leftVideo.play()
        } else if (newPosition < pausetrigger) {
          // console.log("PAUSE", oldVal)
          this.$refs.leftVideo.pause()
          this.$refs.leftVideo.currentTime = 0
        }
      }
    },
    determineRightContainerVideoState(newVal, oldVal) {
      let oldPosition = this.position(oldVal);
      let newPosition = this.position(newVal);
      let pausetrigger = this.rightContainerPauseTrigger;
      let playTrigger = this.rightContainerPlayTrigger;
      // console.log("PAUSETRIGGER", pausetrigger)
      // console.log("PLAYTRIGGER", playTrigger)
      // console.log("position", newPosition)
      if (oldPosition <= playTrigger) {
        if (newPosition > playTrigger) {
          // console.log("PLAY", oldVal)
          this.$refs.rightVideo.play()
        } else if (newPosition < pausetrigger) {
          // console.log("PAUSE", oldVal)
          this.$refs.rightVideo.pause()
          this.$refs.rightVideo.currentTime = 0
        }
      }
    }
  },
}
</script>

<style lang="scss" src="../../styles/featuredualcontentvideocard.scss" scoped/>